// extracted by mini-css-extract-plugin
export default {"qrCode":"onboarding-qrcode_qrCode__2HnFh","text":"onboarding-qrcode_text__d8Zkn"};